<div class="clearfix full-width">
    <div style="text-align: right;" class="pull-right">
        <mat-spinner *ngIf="loadingAction" matSuffix [diameter]="20"></mat-spinner>
        <button *ngIf="!loadingAction" matTooltip="Cancelar" (click)="cancel()" mat-icon-button class="card-inline">
    <mat-icon>clear</mat-icon>
  </button>
        <button *ngIf="!loadingAction && !isViewMode" matTooltip="Finalizar atención" (click)="finalizeMedicalAppointmentCare()" mat-icon-button class="card-inline">
    <mat-icon>done</mat-icon>
  </button>
        <button *ngIf="!loadingAction" mat-icon-button [matMenuTriggerFor]="menuItem">
    <mat-icon>more_vert</mat-icon>
  </button>
        <mat-menu #menuItem="matMenu">
            <button mat-menu-item>
      <mat-icon>search</mat-icon><span>Ver solicitud HIS</span>
    </button>
            <button (click)="openMedicalAppointmentObservationDialog()" mat-menu-item>
      <mat-icon>search</mat-icon><span>Ver observaciones</span>
    </button>
            <app-medical-appointment-reappointment-control *ngIf="!isViewMode"  (onReAppointmentChange)="onReAppointmentChange()" [medicalAppointmentId]="medicalAppointmentId">
            </app-medical-appointment-reappointment-control>
            <button *ngIf="!isViewMode" (click)="keepMedicalAppointmentCare()" mat-menu-item>
      <mat-icon>flag</mat-icon><span>Mantener inicio atención</span>
    </button>
        </mat-menu>
        <audio #audio autoplay></audio>
    </div>
</div>

<mat-tab-group [selectedIndex]="tabIndex">
    <mat-tab *ngIf="enabledVideoChat" label="Video chat">
        <div class="card-base  margin-botton-medium">
            <div class="card-content-wizard">
                <div class="full-width text-center">
                    <button *ngIf="calling && !videoChatVisible" class="animated pulse slow infinite" (click)="startVideoChat()" type="button" mat-fab>
                        <mat-icon>call</mat-icon>
                    </button>
                    <h2 class="animated pulse infinite" *ngIf="noConnection">El paciente no se encuentra conectado, intente nuevamente en unos segundos...</h2>
                </div>
            </div>
        </div>
    </mat-tab>
    <mat-tab *ngIf="!onlyViewHc" label="Escaneos">
        <div class="card-base  margin-botton-medium">
            <div class="card-content-scan">
                <div class="card-container mat-elevation-z1">
                    <div class="card-content">
                        <medical-order-scann-control [medicalorderId]="medicalorderId"></medical-order-scann-control>
                    </div>
                </div>
            </div>
        </div>

    </mat-tab>
    <mat-tab label="Datos generales">
        <div class="card-base  margin-botton-medium">
            <div class="card-content-wizard">
                <medical-service-care-component #medicalServiceCareComponent></medical-service-care-component>
            </div>
        </div>
    </mat-tab>
    <mat-tab *ngIf="!onlyViewHc" label="Paciente">
        <div class="card-base  margin-botton-medium">
            <div class="card-content-wizard">
                <medical-service-patient-component></medical-service-patient-component>
            </div>
        </div>
    </mat-tab>
    <mat-tab *ngIf="!onlyViewHc && canViewReferringPhysician" label="Médico derivante">
        <app-medical-service-referring-physician-component></app-medical-service-referring-physician-component>
    </mat-tab>
    <mat-tab *ngIf="!onlyViewHc && canViewStudyReportRegion" label="Subesp. informe">
        <app-medical-service-study-delivery></app-medical-service-study-delivery>
    </mat-tab>
    <mat-tab *ngIf="!onlyViewHc" label="HC Imágenes">
        <div class="card-base  margin-botton-medium">
            <div class="card-content-wizard">
                <medical-service-clinic-history-component></medical-service-clinic-history-component>
            </div>
        </div>
    </mat-tab>
    <mat-tab label="HC Consultas">
        <div class="card-base  margin-botton-medium">
            <div class="card-content-wizard">
                <app-medical-service-consultation-history-component #medicalServiceConsultationHistoryComponent></app-medical-service-consultation-history-component>
            </div>
        </div>
    </mat-tab>
    <mat-tab *ngIf="!onlyViewHc" label="Operaciones">
        <div class="card-base margin-botton-medium">
            <div class="card-content-scan">
                <medical-service-operation-component></medical-service-operation-component>
            </div>
        </div>
    </mat-tab>
</mat-tab-group>
